"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAspectRatioWithBleed = exports.getBleed = exports.BLEED_TYPES = void 0;
const tiles_1 = require("./tiles");
const honeycomb_1 = require("./honeycomb");
const tiles_2 = require("../utils/tiles");
const artConsts_1 = require("./artConsts");
var BLEED_TYPES;
(function (BLEED_TYPES) {
    BLEED_TYPES["NONE"] = "none";
    BLEED_TYPES["FULL_WRAP"] = "fullWrap";
    // Used for some sizes (i.e - HONEYCOMB sizes) that needs a "buffer" that the factory requires
    // because of manufacturing concerns.The buffer part is cropped by the factory and doesn't exist
    // on the final image
    BLEED_TYPES["BUFFER"] = "buffer";
})(BLEED_TYPES = exports.BLEED_TYPES || (exports.BLEED_TYPES = {}));
const NO_BLEED = {
    bleedType: BLEED_TYPES.NONE,
    bleedHeight: 0,
    bleedWidth: 0,
};
const PLASTIC_BLEED_8X8 = {
    bleedType: BLEED_TYPES.BUFFER,
    bleedHeight: 0.27,
    bleedWidth: 0.27,
};
const FRAMELESS_BLEED = {
    [tiles_1.TILE_SIZES.SQUARE_8X8]: { bleedWidth: 0.09, bleedHeight: 0.09, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_8X11]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_11X8]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.SQUARE_12X12]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_12X16]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_16X12]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.SQUARE_20X20]: { bleedWidth: 0.25, bleedHeight: 0.25, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_20X27]: { bleedWidth: 0.25, bleedHeight: 0.25, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_27X20]: { bleedWidth: 0.25, bleedHeight: 0.25, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_27X36]: NO_BLEED,
    [tiles_1.TILE_SIZES.RECTANGLE_36X27]: NO_BLEED,
    [tiles_1.TILE_SIZES.RECTANGLE_22X44]: NO_BLEED,
    [tiles_1.TILE_SIZES.RECTANGLE_44X22]: NO_BLEED,
};
const MDF_FRAMED_BLEED = {
    [tiles_1.TILE_SIZES.SQUARE_8X8]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_8X11]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_11X8]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.SQUARE_12X12]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_12X16]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_16X12]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.SQUARE_20X20]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_20X27]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_27X20]: { bleedWidth: 0.125, bleedHeight: 0.125, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_27X36]: { bleedWidth: 0.292, bleedHeight: 0.292, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_36X27]: { bleedWidth: 0.292, bleedHeight: 0.292, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_22X44]: { bleedWidth: 0.162, bleedHeight: 0.162, bleedType: BLEED_TYPES.BUFFER },
    [tiles_1.TILE_SIZES.RECTANGLE_44X22]: { bleedWidth: 0.162, bleedHeight: 0.162, bleedType: BLEED_TYPES.BUFFER },
};
function getBleed({ materialType, tileSize, shouldAddBuffer = false, isPlastic = true, }) {
    const { bleedHeight, bleedWidth, bleedType } = getPortraitBleed({
        materialType,
        tileSize,
        shouldAddBuffer,
        isPlastic,
    });
    if ((0, tiles_2.tileSizeToOrientation)(tileSize) === artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE) {
        return {
            bleedHeight: bleedWidth,
            bleedWidth: bleedHeight,
            bleedType,
        };
    }
    return {
        bleedWidth,
        bleedHeight,
        bleedType,
    };
}
exports.getBleed = getBleed;
function getPortraitBleed({ materialType, tileSize, shouldAddBuffer, isPlastic, }) {
    if (materialType === tiles_1.MATERIAL_TYPES.CANVAS) {
        return {
            bleedType: BLEED_TYPES.FULL_WRAP,
            bleedHeight: 1,
            bleedWidth: 1,
        };
    }
    else if (materialType === tiles_1.MATERIAL_TYPES.WIDE_FRAME) {
        return {
            bleedType: BLEED_TYPES.BUFFER,
            bleedHeight: 0.125,
            bleedWidth: 0.125,
        };
    }
    else if ((0, honeycomb_1.isHoneycomb)(tileSize)) {
        return {
            bleedType: BLEED_TYPES.BUFFER,
            bleedHeight: 0.145,
            bleedWidth: 0.125,
        };
    }
    else if (shouldAddBuffer && materialType === tiles_1.MATERIAL_TYPES.FRAMELESS) {
        return FRAMELESS_BLEED[tileSize] || NO_BLEED;
    }
    else if (shouldAddBuffer && materialType === tiles_1.MATERIAL_TYPES.CLASSIC) {
        return isPlastic && tileSize === tiles_1.TILE_SIZES.SQUARE_8X8
            ? PLASTIC_BLEED_8X8
            : MDF_FRAMED_BLEED[tileSize] || NO_BLEED;
    }
    else {
        return NO_BLEED;
    }
}
/**
 * Given a tileSize and bleed sizes, returns the aspect ratio of the expected frame.
 * @param {string} materialType
 * @param {string} tileSize
 * @param {number} bleedWidth - how many inches to add from the left and right of the image
 * @param {number} bleedHeight - how many inches to add from the top and bottom of the image
 */
function getAspectRatioWithBleed({ materialType, tileSize, bleedHeight, bleedWidth, }) {
    if (!tileSize) {
        return null;
    }
    let dimensions = tiles_1.TILESIZES_TO_INCHES[tileSize];
    if (!dimensions) {
        return null;
    }
    // Include frame width in calculation of aspect ratio otherwise the image will be squashed slightly (but it's more apparent with Wide Frame)
    const frameWidth = (0, tiles_2.getFrameWidth)({ materialType, tileSize });
    dimensions = {
        width: dimensions.width - 2 * frameWidth,
        height: dimensions.height - 2 * frameWidth,
    };
    const widthWithBleed = dimensions.width + 2 * bleedWidth; // Multiply by 2 because we add bleed from both sides
    const heightWithBleed = dimensions.height + 2 * bleedHeight; // Multiply by 2 because we add bleed from both sides
    return widthWithBleed / heightWithBleed;
}
exports.getAspectRatioWithBleed = getAspectRatioWithBleed;
//# sourceMappingURL=bleed.js.map